import { createContext, useContext, useMemo, ReactNode } from 'react';
import { TruktTmsApi } from '@trukt/tms-api';
import { TrimbleMapsSingleSearchApi } from '@trukt/utils/TrimbleMapsSingleSearchApi';

export interface ApiProviderValue {
  truktApi: TruktTmsApi;
  trimbleApi: TrimbleMapsSingleSearchApi | null;
}

export interface ApiProviderProps extends ApiProviderValue {
  children: ReactNode;
}

const ApiContext = createContext<ApiProviderValue | undefined>(undefined);

export const ApiProvider = ({ children, trimbleApi, truktApi }: ApiProviderProps) => {
  const value = useMemo(() => ({ truktApi, trimbleApi }), []);
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};

export const useApiContext = () => {
  const context = useContext(ApiContext);

  if (!context) throw new Error('useApiContext must be used within a ApiProvider');

  return context;
};
